import { render } from "./SonicuHeader.vue?vue&type=template&id=3f68dfb4"
import script from "./SonicuHeader.vue?vue&type=script&lang=js"
export * from "./SonicuHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__